import { render, staticRenderFns } from "./shopNameAuto.vue?vue&type=template&id=c70b1080"
import script from "./shopNameAuto.vue?vue&type=script&lang=js"
export * from "./shopNameAuto.vue?vue&type=script&lang=js"
import style0 from "./shopNameAuto.vue?vue&type=style&index=0&id=c70b1080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports